export const DAILY_GOALS_COLORS = {
  PURPLE_400: 'rgb(105 35 222 / 40%)', // maps closest to cds quaternary-background-xstrong with custom opacity
} as const;
